import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import Header from "../../../header/Header";
import Aside from "../../../aside/Aside";
import HeaderModulo from "../../../header/HeaderModulo";
import { alerta, formatDate, toast } from "../../../../services/utilities";
import { getListaEmpresas } from "../../../../services/root";
import { editarResultadoAjuste, getEncabezadoResultadoRoot } from "../../../../services/Resultados";
import Swal from "sweetalert2";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Skeleton } from "primereact/skeleton";

function Resultados(props) {
    const initialResultadoState = {
        id_encabezado_resultado: 0,
        fecha: "",
        observacion: "",
        estado_id: "",
        empresa_id: "",
        usuario_creacion_id: null,
        nombre: "",
        resultado_loteria: [],
    };

    const [spiner, setSpiner] = useState(false);
    const [listaEmpresas, setListaEmpresas] = useState([]);
    const [consultado, setConsultado] = useState(false);
    const [guardando, setGuardando] = useState(false);
    const [filtroTabla, setFiltroTabla] = useState("");
    const [fechaMaxima] = useState(formatDate(new Date()));
    const [fechaMinima] = useState(() => {
        const fecha = new Date();
        fecha.setDate(fecha.getDate() - 10);
        return formatDate(fecha);
    });
    const [filtro, setFiltro] = useState({
        id_empresa: "",
        fecha: formatDate(new Date()),
    });
    const [resultado, setResultado] = useState(initialResultadoState);
    const [resultadoOriginal, setResultadoOriginal] = useState(null);

    const signos = [
        "Aries",
        "Tauro",
        "Geminis",
        "Cancer",
        "Leo",
        "Virgo",
        "Libra",
        "Escorpion",
        "Sagitario",
        "Capricornio",
        "Acuario",
        "Piscis",
    ];

    useEffect(() => {
        handleCargarEmpresas();
    }, []);

    const handleCargarEmpresas = async () => {
        setSpiner(true);

        try {
            await getListaEmpresas().then((response) => {
                if (response.status === 200) {
                    setListaEmpresas(response.data.data);
                } else {
                    alerta("No fue posible cargar la lista de empresas", "", "warning");
                }
            });
        } catch (error) {
            alerta("Error no controlado al cargar la información de empresas (root/lista/empresas) ->" + error);
        } finally {
            setSpiner(false);
        }
    };

    const handleInputFiltroChange = (event) => {
        const { name, value } = event.target;
        setFiltro({ ...filtro, [name]: value });
    };

    const handleToggleEdicionFila = (id_resultado_loteria) => {
        setResultado((prevResultado) => ({
            ...prevResultado,
            resultado_loteria: prevResultado.resultado_loteria.map((item) => {
                if (item.id_resultado_loteria !== id_resultado_loteria) {
                    return item;
                }

                return {
                    ...item,
                    __editable: !item.__editable,
                };
            }),
        }));
    };

    const handleInputResultadoChange = (event, id_resultado_loteria = false) => {
        const { name, value } = event.target;

        if (id_resultado_loteria === false) {
            setResultado((prevResultado) => ({
                ...prevResultado,
                [name]: value,
            }));
            return;
        }

        setResultado((prevResultado) => ({
            ...prevResultado,
            resultado_loteria: prevResultado.resultado_loteria.map((item) => {
                if (item.id_resultado_loteria !== id_resultado_loteria) {
                    return item;
                }

                return {
                    ...item,
                    numero: name.startsWith("numero_") ? value : item.numero,
                    serie: name.startsWith("serie_") ? value : item.serie,
                    signo: name.startsWith("astro_") ? value : item.signo,
                };
            }),
        }));
    };

    const handleValidarFiltro = () => {
        if (filtro.id_empresa === "") {
            toast("Seleccione una empresa", "Debe indicar la empresa a consultar", "warning");
            return false;
        }

        if (filtro.fecha === "") {
            toast("Seleccione una fecha", "Debe indicar la fecha del ajuste", "warning");
            return false;
        }

        if (filtro.fecha < fechaMinima || filtro.fecha > fechaMaxima) {
            toast(
                "Fecha inválida",
                `La fecha debe estar entre ${fechaMinima} y ${fechaMaxima}`,
                "warning"
            );
            return false;
        }

        return true;
    };

    const handleConsultar = async () => {
        if (!handleValidarFiltro()) {
            return;
        }

        setSpiner(true);
        setConsultado(true);
        setFiltroTabla("");
        setResultado(initialResultadoState);
        setResultadoOriginal(null);

        try {
            await getEncabezadoResultadoRoot(filtro.id_empresa, filtro.fecha).then((response) => {
                if (response.status === 200) {
                    const dataResultado = {
                        ...response.data.data,
                        resultado_loteria: Array.isArray(response.data.data.resultado_loteria)
                            ? response.data.data.resultado_loteria.map((item) => ({
                                  ...item,
                                  __editable: false,
                              }))
                            : [],
                    };

                    setResultado(dataResultado);
                    setResultadoOriginal(JSON.parse(JSON.stringify(dataResultado)));
                } else {
                    setResultado(initialResultadoState);
                    setResultadoOriginal(null);
                    toast(
                        "Sin resultados",
                        response.response?.data?.status_message ?? response.message ?? "No hay resultado de búsqueda",
                        "warning"
                    );
                }
            });
        } catch (error) {
            alerta("Error no controlado al consultar resultados (resultado/encabezado/root) ->" + error);
        } finally {
            setSpiner(false);
        }
    };

    const handleConstruirResumenCambios = () => {
        if (!resultadoOriginal) {
            return [];
        }

        const cambios = [];

        if ((resultadoOriginal.observacion ?? "") !== (resultado.observacion ?? "")) {
            cambios.push(
                `Observación: "${resultadoOriginal.observacion ?? ""}" -> "${resultado.observacion ?? ""}"`
            );
        }

        resultado.resultado_loteria.forEach((itemActual) => {
            const itemOriginal = resultadoOriginal.resultado_loteria.find(
                (item) => item.id_resultado_loteria === itemActual.id_resultado_loteria
            );

            if (!itemOriginal) {
                return;
            }

            const cambiosFila = [];

            if ((itemOriginal.numero ?? "") !== (itemActual.numero ?? "")) {
                cambiosFila.push(`Numero: "${itemOriginal.numero ?? ""}" -> "${itemActual.numero ?? ""}"`);
            }

            if ((itemOriginal.serie ?? "") !== (itemActual.serie ?? "")) {
                cambiosFila.push(`Serie: "${itemOriginal.serie ?? ""}" -> "${itemActual.serie ?? ""}"`);
            }

            if ((itemOriginal.signo ?? "") !== (itemActual.signo ?? "")) {
                cambiosFila.push(`Astro: "${itemOriginal.signo ?? ""}" -> "${itemActual.signo ?? ""}"`);
            }

            if (cambiosFila.length > 0) {
                cambios.push(`${itemActual.prefijo}: ${cambiosFila.join(" | ")}`);
            }
        });

        return cambios;
    };

    const handleGuardarResultado = async () => {
        if (resultado.id_encabezado_resultado === 0) {
            toast("Sin datos", "No hay resultados cargados para guardar", "warning");
            return;
        }

        const cambios = handleConstruirResumenCambios();

        if (cambios.length === 0) {
            toast("Sin cambios", "No hay cambios para guardar", "warning");
            return;
        }

        const payload = {
            ...resultado,
            resultado_loteria: resultado.resultado_loteria.map(({ __editable, ...item }) => item),
        };

        Swal.fire({
            title: "Resumen de cambios",
            html: `
                <div style="text-align:left; max-height:280px; overflow:auto;">
                    <p><b>Cambios detectados:</b></p>
                    <ul style="padding-left:18px; margin-bottom:16px;">
                        ${cambios.map((item) => `<li>${item}</li>`).join("")}
                    </ul>
                    <p style="margin-bottom:0;"><b>¿Desea guardar y procesar estos cambios?</b></p>
                </div>
            `,
            icon: "info",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Guardar y Procesar",
        }).then(async (confirmacion) => {
            if (!confirmacion.isConfirmed) {
                return;
            }

            setGuardando(true);

            try {
                await editarResultadoAjuste(payload).then((response) => {
                    if (response.status === 200) {
                        const resultadoActualizado = {
                            ...resultado,
                            resultado_loteria: resultado.resultado_loteria.map((item) => ({
                                ...item,
                                __editable: false,
                            })),
                        };

                        setResultado(resultadoActualizado);
                        setResultadoOriginal(JSON.parse(JSON.stringify(resultadoActualizado)));

                        alerta(
                            response.data?.status_message ?? "Proceso terminado",
                            `Total premios: ${response.data?.total_premios ?? 0}\nGanadores eliminados: ${response.data?.ganadores_eliminados ?? 0}`,
                            "success"
                        );
                    } else if (response.response?.status === 404) {
                        alerta(
                            "No hay resultado de busqueda",
                            response.response?.data?.status_message ?? "No hay resultado de busqueda",
                            "warning"
                        );
                    } else if (response.code === "ECONNABORTED") {
                        alerta(
                            "Tiempo de espera agotado",
                            "El proceso tardó más de 2 minutos en responder. Verifique si el ajuste se procesó en el servidor antes de volver a intentarlo.",
                            "warning"
                        );
                    } else {
                        alerta(
                            "Se presentó un error al intentar guardar el resultado",
                            response.response?.data?.status_message ?? response.message
                        );
                    }
                });
            } catch (error) {
                alerta("Error no controlado al guardar el resultado ->" + error);
            } finally {
                setGuardando(false);
            }
        });
    };

    const getEstadoTexto = (estado_id) => {
        return parseInt(estado_id) === 2 ? "Aprobado" : "Pendiente";
    };

    const skeletonRows = Array.from({ length: 6 }, (_, index) => ({
        id: index,
    }));

    const resultadosFiltrados = Array.isArray(resultado.resultado_loteria)
        ? resultado.resultado_loteria.filter((item) =>
              item.prefijo?.toLowerCase().includes(filtroTabla.toLowerCase())
          )
        : [];

    const skeletonTextBody = () => <Skeleton width="100%" height="1.8rem"></Skeleton>;

    const skeletonActionBody = () => <Skeleton width="5rem" height="2rem"></Skeleton>;

    const loteriaBodyTemplate = (rowData) => rowData.prefijo;

    const numeroBodyTemplate = (rowData) => {
        const editable = !!rowData.__editable;

        return (
            <input
                type="number"
                className="form-control form-control-sm"
                name={`numero_${rowData.id_resultado_loteria}`}
                disabled={!editable}
                value={rowData.numero ?? ""}
                onChange={(e) => handleInputResultadoChange(e, rowData.id_resultado_loteria)}
            />
        );
    };

    const serieBodyTemplate = (rowData) => {
        const editable = !!rowData.__editable;

        return (
            <input
                type="number"
                className="form-control form-control-sm"
                name={`serie_${rowData.id_resultado_loteria}`}
                disabled={!editable}
                value={rowData.serie ?? ""}
                onChange={(e) => handleInputResultadoChange(e, rowData.id_resultado_loteria)}
            />
        );
    };

    const astroBodyTemplate = (rowData) => {
        const editable = !!rowData.__editable;

        return (
            <select
                className="form-select form-select-sm"
                name={`astro_${rowData.id_resultado_loteria}`}
                disabled={!editable}
                value={rowData.signo ?? ""}
                onChange={(e) => handleInputResultadoChange(e, rowData.id_resultado_loteria)}
            >
                <option value="">n/a</option>
                {signos.map((signo) => (
                    <option key={signo} value={signo}>
                        {signo}
                    </option>
                ))}
            </select>
        );
    };

    const accionBodyTemplate = (rowData) => {
        const editable = !!rowData.__editable;

        return (
            <button
                type="button"
                className={editable ? "btn btn-sm btn-secondary" : "btn btn-sm btn-outline-primary"}
                onClick={() => handleToggleEdicionFila(rowData.id_resultado_loteria)}
            >
                {editable ? "Bloquear" : "Editar"}
            </button>
        );
    };

    return (
        <React.Fragment>
            <Header></Header>
            <Aside></Aside>
            <main id="main" className="main">
                <section className="section">
                    <HeaderModulo nombre_modulo={props.modulo}></HeaderModulo>

                    <div className="card">
                        <div className="card-body">
                            <h5 className="card-title">Consulta para Ajuste de Resultados</h5>
                            <p className="text-muted">
                                Seleccione la empresa y la fecha del ajuste. Solo se permiten consultas de hoy y hasta 10 días atrás.
                            </p>

                            <div className="row">
                                <div className="col-md-4 mb-3">
                                    <label className="mb-1">Empresa</label>
                                    <select
                                        className="form-select"
                                        name="id_empresa"
                                        value={filtro.id_empresa}
                                        onChange={handleInputFiltroChange}
                                    >
                                        <option value="">-Seleccione-</option>
                                        {Array.isArray(listaEmpresas) && listaEmpresas.length > 0
                                            ? listaEmpresas.map((empresa) => (
                                                  <option key={empresa.id_empresa} value={empresa.id_empresa}>
                                                      {empresa.nombre}
                                                  </option>
                                              ))
                                            : ""}
                                    </select>
                                </div>

                                <div className="col-md-3 mb-3">
                                    <label className="mb-1">Fecha</label>
                                    <input
                                        type="date"
                                        className="form-control"
                                        name="fecha"
                                        value={filtro.fecha}
                                        min={fechaMinima}
                                        max={fechaMaxima}
                                        onChange={handleInputFiltroChange}
                                    />
                                </div>

                                <div className="col-md-2 mb-3">
                                    <label className="mb-1">&emsp;</label>
                                    <div className="d-grid">
                                        <button
                                            type="button"
                                            className="btn btn-outline-primary"
                                            onClick={handleConsultar}
                                            disabled={spiner || guardando}
                                        >
                                            Consultar
                                        </button>
                                    </div>
                                </div>
                            </div>

                            <small className="text-secondary">
                                Rango permitido: {fechaMinima} a {fechaMaxima}
                            </small>
                        </div>
                    </div>

                    {Array.isArray(resultado.resultado_loteria) && resultado.resultado_loteria.length > 0 ? (
                        <div className="card mt-4">
                            <div className="card-body">
                                <div className="row mb-3">
                                    <div className="col-md-3">
                                        <label className="mb-1">Fecha</label>
                                        <input type="date" className="form-control" value={resultado.fecha} disabled={true} />
                                    </div>
                                    <div className="col-md-3">
                                        <label className="mb-1">Estado</label>
                                        <input type="text" className="form-control" value={getEstadoTexto(resultado.estado_id)} disabled={true} />
                                    </div>
                                    <div className="col-md-6">
                                        <label className="mb-1">Observación</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            id="observacion"
                                            name="observacion"
                                            value={resultado.observacion ?? ""}
                                            onChange={handleInputResultadoChange}
                                        />
                                    </div>
                                </div>

                                <div className="row mb-3">
                                    <div className="col-md-4">
                                        <label className="mb-1">Filtrar por lotería</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            placeholder="Nombre de la lotería"
                                            value={filtroTabla}
                                            onChange={(e) => setFiltroTabla(e.target.value)}
                                        />
                                    </div>
                                </div>

                                <DataTable
                                    value={resultadosFiltrados}
                                    dataKey="id_resultado_loteria"
                                    size="small"
                                    rowHover
                                    emptyMessage="No hay loterías para mostrar"
                                >
                                    <Column field="prefijo" header="Lotería" body={loteriaBodyTemplate}></Column>
                                    <Column header="Número" body={numeroBodyTemplate} style={{ width: "18%" }}></Column>
                                    <Column header="Serie" body={serieBodyTemplate} style={{ width: "18%" }}></Column>
                                    <Column header="Astro" body={astroBodyTemplate} style={{ width: "20%" }}></Column>
                                    <Column header="Acción" body={accionBodyTemplate} style={{ width: "12%" }}></Column>
                                </DataTable>

                                <div className="d-flex justify-content-end mt-3">
                                    <button
                                        type="button"
                                        className="btn btn-primary"
                                        onClick={handleGuardarResultado}
                                        disabled={guardando || spiner}
                                    >
                                        {guardando ? (
                                            <span className="spinner-border spinner-border-sm me-2" aria-hidden="true"></span>
                                        ) : (
                                            ""
                                        )}
                                        Guardar y Procesar
                                    </button>
                                </div>
                            </div>
                        </div>
                    ) : (
                        ""
                    )}

                    {consultado && !spiner && resultado.id_encabezado_resultado === 0 ? (
                        <div className="text-center text-secondary my-4">
                            <h4>Sin resultado de búsqueda para los filtros aplicados.</h4>
                            <p>No se encontró un encabezado de resultados para la empresa y fecha seleccionadas.</p>
                        </div>
                    ) : (
                        ""
                    )}

                    {spiner ? (
                        <div className="card mt-4">
                            <div className="card-body">
                                <div className="row mb-3">
                                    <div className="col-md-3">
                                        <Skeleton height="2.5rem"></Skeleton>
                                    </div>
                                    <div className="col-md-3">
                                        <Skeleton height="2.5rem"></Skeleton>
                                    </div>
                                    <div className="col-md-6">
                                        <Skeleton height="2.5rem"></Skeleton>
                                    </div>
                                </div>
                                <DataTable value={skeletonRows} size="small">
                                    <Column header="Lotería" body={skeletonTextBody}></Column>
                                    <Column header="Número" body={skeletonTextBody}></Column>
                                    <Column header="Serie" body={skeletonTextBody}></Column>
                                    <Column header="Astro" body={skeletonTextBody}></Column>
                                    <Column header="Acción" body={skeletonActionBody}></Column>
                                </DataTable>
                            </div>
                        </div>
                    ) : (
                        ""
                    )}
                </section>
            </main>
        </React.Fragment>
    );
}

const mapSateToProps = (state) => {
    return {
        data_sesion: state.data_sesion,
    };
};

export default connect(mapSateToProps, null)(Resultados);
